// hiveMind is the central orchestrator for the zit webapp framework.
// The 'app' property must be set externally (by the theme's index.js) before calling main().
const hiveMind = {
    app: null,
    helper: require('./helper'),
    validator: require('./validator'),
    msgs: require('./messages'),
    session: require('./session'),
    // Behaviour contract — stub by default; framework themes (bootstrap5,
    // zitTailwind, …) replace this whole module from their own index.js before
    // calling main(). Calling any stub throws. See scripts/behaviors.contract.md.
    behaviors: require('./behaviors'),

    main: function () {
        for (let component in this) {
            this.adopt(this[component]);
        }

        this.app.init();
    },

    newComponent: function (componentType) {
        let component = false;

        // 1. Try the extending theme's components directory (via the injected hook).
        component = this.requireComponent(componentType);

        // 2. Fall back to base's own components directory for the requested type.
        if (component === false) {
            try {
                component = require('../components/' + componentType + '/' + componentType);
            } catch (e) {
                component = false;
            }
        }

        // 3. Type not found anywhere: fall back to the theme's base component override.
        if (component === false) {
            component = this.requireComponent('component');
        }

        // 4. Absolute last resort: base's base component (always exists).
        if (component === false) {
            component = require('../components/component/component');
        }

        // Use JSON round-trip to create a deep clone with fresh properties,
        // preventing child components from sharing sub-object references
        let newComponent = Object.assign({}, component, JSON.parse(JSON.stringify(component)));

        this.adopt(newComponent);

        newComponent.componentType = componentType;

        return newComponent;
    },

    // Injected by the theme's index.js so webpack creates the right file context
    // for that theme's components directory. Override this before calling main().
    requireComponent: function (componentType) {
        return false;
    },

    // Injected by the theme's index.js so webpack creates the right file context
    // for that theme's controllers directory. Override this before calling main().
    requireController: function (controllerPath) {
        return false;
    },

    newController: function (controllerPath) {
        if (typeof controllerPath === typeof undefined) {
            controllerPath = this.app.controller + '/' + this.app.controller;
        }

        let controller = this.requireController(controllerPath);

        if (controller !== false) {
            this.adopt(controller);
        }

        return controller;
    },

    // Sets hm (this hiveMind instance) on a module object if the module declares it
    adopt: function (object) {
        if (Object.hasOwn(object, 'hm')) {
            object.hm = this;
        }
    },

    log: function (...variables) {
        this.helper.toConsole('log', ...variables);
    },

    warn: function (...variables) {
        this.helper.toConsole('warn', ...variables);
    },

    error: function (...variables) {
        this.helper.toConsole('error', ...variables);
    }
};

module.exports = hiveMind;
